import { createSlice } from '@reduxjs/toolkit'
import AnomaliesServices from '../../services/anomaliesServices';
import { useCurrentUserContext } from '../../context/currentUserContext';


const initialState = {
  anomalies: []
};

const anomaliesSlice = createSlice({
  name: 'anomalies',
  initialState,
  reducers: {
    anomaliesLoaded(state, action) {
      state.anomalies = action.payload;
    }
  },
})

export const { anomaliesLoaded } = anomaliesSlice.actions;

export default anomaliesSlice.reducer;

export const fetchAnomaliesList = (categoryID) => async (dispatch) => { 
  try {
    let filters={anomalyName: "", isEnabled: true};
    const respData = await AnomaliesServices.getAnomalies(filters, categoryID);
    if (respData.success) {
      const anomaliesList = respData.responseObject.value.anomaliesListDTO;    

      if(anomaliesList){
        const objectsArray = anomaliesList.map((item) => ({ value: item.id, label: item.name }));
        dispatch(anomaliesLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

